import { render, staticRenderFns } from "./SmartScreen.vue?vue&type=template&id=5b8d4baa&scoped=true&"
import script from "./SmartScreen.vue?vue&type=script&lang=js&"
export * from "./SmartScreen.vue?vue&type=script&lang=js&"
import style0 from "./SmartScreen.vue?vue&type=style&index=0&id=5b8d4baa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8d4baa",
  null
  
)

export default component.exports